import React from 'react';
import classNames from 'classnames';
import usePastTime from 'hooks/usePastTime';

import './SuggestedActionInstance.styles.scss';

type SuggestedActionInstanceProps = {
  className?: string;
  title: string;
  date: Date;
  subject?: string;
};

const SuggestedActionInstance: React.FC<SuggestedActionInstanceProps> = (
  props,
) => {
  const { children, className, date, title, subject } = props;

  const classes = classNames(
    'suggested-action-instance',
    'white-panel',
    className,
  );

  const renderDate = usePastTime()(date);

  return (
    <div className={classes}>
      <div className="heading">
        <p>{title}</p>
        <span>{renderDate}</span>
      </div>

      {subject && <p className="subject">{subject}</p>}

      {children}
    </div>
  );
};

export default SuggestedActionInstance;
